import { render, staticRenderFns } from "./EmptyReviews.vue?vue&type=template&id=ba35214a&scoped=true&"
import script from "./EmptyReviews.vue?vue&type=script&lang=js&"
export * from "./EmptyReviews.vue?vue&type=script&lang=js&"
import style0 from "./EmptyReviews.vue?vue&type=style&index=0&id=ba35214a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba35214a",
  null
  
)

export default component.exports